"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibilityMapProperty = exports.createBackgroundWorkStateSelector = void 0;
var _createSelector = _interopRequireDefault(require("../../../Utils/Function/createSelector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createBackgroundWorkStateSelector = exports.createBackgroundWorkStateSelector = function createBackgroundWorkStateSelector() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return (0, _createSelector["default"])(function (uiState) {
    return uiState.backgroundWorkMap;
  }, function (backgroundWorkMap) {
    return names.reduce(function (result, name) {
      return backgroundWorkMap[name] || result;
    }, false);
  });
};
var getVisibilityMapProperty = exports.getVisibilityMapProperty = function getVisibilityMapProperty(state, name) {
  return state.visibilityMap[name];
};